import React, { Fragment } from "react";
import { BettingInterest, Changes, RaceTypeCodeEnum } from "@tvg/ts-types/Race";
import { Header, Tag, useTheme } from "@tvg/design-system";
import {
  getPickRunnerOdds,
  isBiScratched
} from "@tvg/desktop-bet/src/utils/betUtils";
import {
  PicksSelectorHandicappingContainer,
  PicksSelectorHandicappingEntry,
  PicksSelectorRunnerContainer,
  PicksSelectorRunnerName,
  PicksSelectorRunnerNameContainer,
  PicksSelectorRunnerNameSeparator,
  PicksSelectorRunnerOddsContainer
} from "./styled-components";
import RunnerChangeIndicator from "../../Runner/components/RunnerChangeIndicator";

const PickSelectorRunnerEntry = (props: {
  bi: BettingInterest;
  isDriver: boolean;
  raceChanges?: Changes;
}) => {
  const theme = useTheme();

  const isScratched = isBiScratched(props.bi);
  const runnerOdds = getPickRunnerOdds(props.bi);

  const getJockeyChanges = (runnerNumber: string) => {
    const jockeyChanges = props.raceChanges?.horse?.jockey?.filter(
      (jockeyChange) => jockeyChange.runnerId === runnerNumber
    );

    return jockeyChanges || [];
  };

  return (
    <PicksSelectorRunnerContainer theme={theme}>
      <PicksSelectorRunnerNameContainer
        theme={theme}
        isScratched={!!isScratched}
        data-qa-label={`runner-name-container-${props.bi?.biNumber}`}
      >
        <Header
          fontFamily="medium"
          fontSize="m"
          tag="h2"
          color="grey.900"
          qaLabel={`runnerName-${props.bi?.biNumber}`}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          <>
            {props.bi?.runners.map((runner, index) => (
              // eslint-disable-next-line
              <Fragment key={`runnerName-${runner.horseName}-${index}`}>
                <PicksSelectorRunnerName
                  theme={theme}
                  isScratched={runner.scratched}
                  data-qa-la={`runner-name-${runner.horseName}`}
                >{`${runner.horseName}`}</PicksSelectorRunnerName>
                {index !== props.bi?.runners.length - 1 ? (
                  <PicksSelectorRunnerNameSeparator theme={theme}>
                    /
                  </PicksSelectorRunnerNameSeparator>
                ) : (
                  ""
                )}
              </Fragment>
            ))}
          </>
        </Header>
        <PicksSelectorHandicappingContainer theme={theme}>
          {props.bi?.runners.map((runner, index) => (
            // eslint-disable-next-line
            <Fragment key={`runnerInfo-${runner.jockey}-${index}`}>
              <PicksSelectorHandicappingEntry
                isScratched={runner.scratched}
                data-qa-label={`runner-jockey-${runner.jockey}-trainer-${runner.trainer}`}
              >
                {`${props.isDriver ? "D" : "J"}: ${runner.jockey}`}
                {getJockeyChanges(runner.runnerId).length ? (
                  <RunnerChangeIndicator
                    mr="space-1"
                    raceTypeCode={
                      props.isDriver
                        ? RaceTypeCodeEnum.HARNESS
                        : RaceTypeCodeEnum.ALL
                    }
                    jockeyChanges={getJockeyChanges(runner.runnerId)}
                  />
                ) : (
                  ""
                )}
                {`| T: ${runner.trainer}`}
              </PicksSelectorHandicappingEntry>
              {index !== props.bi?.runners.length - 1 ? (
                <PicksSelectorRunnerNameSeparator theme={theme}>
                  /
                </PicksSelectorRunnerNameSeparator>
              ) : (
                ""
              )}
            </Fragment>
          ))}
        </PicksSelectorHandicappingContainer>
      </PicksSelectorRunnerNameContainer>
      <PicksSelectorRunnerOddsContainer>
        {props.bi?.favorite && !isScratched && (
          <Tag
            qaLabel="race-card-tag-fav"
            size="s"
            variant="fav"
            label="FAV"
            mr="space-3"
            my="auto"
          />
        )}
        {isScratched && (
          <Tag
            size="m"
            variant="info"
            label="Scratched"
            qaLabel="race-card-scratched-label"
          />
        )}
        {!isScratched && (
          <Header
            tag="h3"
            fontFamily="medium"
            qaLabel={`race-card-current-odd-${runnerOdds}`}
            color="grey.900"
          >
            {runnerOdds}
          </Header>
        )}
      </PicksSelectorRunnerOddsContainer>
    </PicksSelectorRunnerContainer>
  );
};

export default PickSelectorRunnerEntry;
